import { type EmbeddedVideosFiltersEnum } from "features/Library/EmbeddedVideos/types/models";
import React, { type FC } from "react";
import { FilterFormBuilder } from "../FilterFormBuilder/FilterFormBuilder";
import { type FilterFormPropsBase } from "../types/props";
import { getEmbeddedVideosFilters } from "./embeddedVideosFiltersUtils";

export interface EmbeddedVideosFilterFormProps extends FilterFormPropsBase<EmbeddedVideosFiltersEnum> {
  disableDateFilters: boolean;
}

const EmbeddedVideosFilterForm: FC<EmbeddedVideosFilterFormProps> = ({
  filterOptions,
  filter,
  updateFilter,
  disableDateFilters,
  onValidationChange,
}) => (
  <FilterFormBuilder
    filterOptions={filterOptions}
    filter={filter}
    updateFilter={updateFilter}
    items={getEmbeddedVideosFilters(true, disableDateFilters)}
    onValidationChange={onValidationChange}
  />
);

export default EmbeddedVideosFilterForm;
